module.exports = __webpack_public_path__ + "img/top.6d161e7a.png";